import { render } from "./TimelineList.vue?vue&type=template&id=8b0a4b86"
import script from "./TimelineList.vue?vue&type=script&lang=js"
export * from "./TimelineList.vue?vue&type=script&lang=js"

import exportComponent from "/home/leandro/trabalho-timo/kuhlenbier-web-frontend-partner/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__